export { Ng2StompModule } from './ng2-stomp.module';
export { Ng2StompService } from './ng2-stomp.service';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
